import React from 'react';
import { DRAW_MACHINE, RAFFLE, RAFFLE_PAGES } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import './Raffle.css';
import { userInfoSelector } from '../../redux/selectors/auth';
import { listMachine } from '../../redux/actions/settings';
import {
  loadingSelector,
  machineSelector,
} from '../../redux/selectors/settings';
import ManageRaffleStepper from './ManageRaffleStepper';
import {
  raffleCustomersSelector,
  rafflesSelector,
} from '../../redux/selectors/customer';
import {
  clearAllCustomers,
  deleteRaffle,
  listAllRaffles,
  listRaffleCustomers,
  saveRaffle,
  uploadRafflePhoto,
} from '../../redux/actions/customer';
import RaffleTable from './RaffleTable';
import DrawIcon from '@mui/icons-material/Draw';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CustomToolbar from '../global/CustomToolbar';
import SessionReportPdf from '../global/SessionReportPdf';

class Raffle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: RAFFLE_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      feedbackStatus: '',
      feedbackMessage: '',
      isHideToolbar: false,
      // report
      reportTrigger: 0,
    };
  }

  async componentDidUpdate(prevProps) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar('error', this.props.status.statusText);
    }
  }

  componentDidMount() {
    this.props.listMachine(this.props.user.selectedLocationId);
    this.props.listAllRaffles({ userId: this.props.user.userId });
  }

  // report — generates the new employee-session PDF for this employee's
  // latest shift (bumping reportTrigger fires SessionReportPdf).
  fetchPdf = () => {
    this.setState((s) => ({ reportTrigger: s.reportTrigger + 1 }));
  };

  handleReportError = (message) => {
    this.openFeedbackBar('error', message);
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displayTable = () => {
    return (
      <RaffleTable
        handleDeleteRow={this.handleDeleteRow}
        raffles={this.props.raffles}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
      />
    );
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case RAFFLE_PAGES.DISPLAY:
        return this.displayStepper();
      case RAFFLE_PAGES.TABLE:
        return this.displayTable();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  displayStepper = () => {
    return (
      <ManageRaffleStepper
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        machines={this.props.machines}
        raffleCustomers={this.props.raffleCustomers}
        fetchSearch={this.fetchSearch}
        loadingData={this.props.loadingData}
        saveRaffle={this.props.saveRaffle}
        uploadRafflePhoto={this.props.uploadRafflePhoto}
        user={this.props.user}
        clearAllCustomers={this.props.clearAllCustomers}
        setDisableToolBar={this.setDisableToolBar}
      />
    );
  };

  handleDeleteRow = (deleteId) => {
    this.props.deleteRaffle({ raffleId: deleteId });
  };

  fetchSearch = (name) => {
    this.props.listRaffleCustomers({
      search: name,
      locationId: this.props.user.selectedLocationId,
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  setDisableToolBar = (bool) => {
    this.setState({ isHideToolbar: bool });
  };

  render() {
    const { user } = this.props;
    const headerButtons = [
      {
        title: DRAW_MACHINE,
        icon: <DrawIcon />,
        handler: () => {
          this.setDisableToolBar(true);
          this.setCurrentPage(RAFFLE_PAGES.DISPLAY, {});
        },
      },
      {
        icon: <VisibilityIcon />,
        title: 'View Report',
        handler: () => this.fetchPdf(),
      },
    ];

    return (
      <React.Fragment>
        {!this.state.isHideToolbar && (
          <CustomToolbar
            title={RAFFLE}
            createTitle={''}
            backTitle={''}
            headerButtons={headerButtons}
          />
        )}

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {this.state.currentPage === RAFFLE_PAGES.DISPLAY ? (
          <div className="raffle-stepper-shell">{this.displayCurrentPage()}</div>
        ) : (
          <div className="raffle-page-root">{this.displayCurrentPage()}</div>
        )}

        <SessionReportPdf
          type="raffle"
          userId={user.userId}
          locationId={user.selectedLocationId}
          locationName={user.selectedLocationName}
          trigger={this.state.reportTrigger}
          onError={this.handleReportError}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  machines: machineSelector(state),
  raffleCustomers: raffleCustomersSelector(state),
  raffles: rafflesSelector(state),
  loadingData: loadingSelector(state),
});

const actionCreators = {
  clearStatus,
  listMachine,
  listRaffleCustomers,
  listAllRaffles,
  deleteRaffle,
  saveRaffle,
  uploadRafflePhoto,
  clearAllCustomers,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  Raffle
);
